"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonSource = void 0;
const core_1 = require("flow-connect/core");
const utils_1 = require("flow-connect/utils");
const ui_1 = require("flow-connect/ui");
class JsonSource extends core_1.Node {
    constructor() {
        super();
    }
    setupIO() {
        this.addTerminals([{ type: core_1.TerminalType.OUT, name: "value", dataType: "any" }]);
    }
    created(options) {
        const { width = 150, name = "JSON Source", style = {}, state = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.state = Object.assign({ value: "" }, state);
        this.setupUI();
        this.setupListeners();
    }
    process() {
        if (!this.input.value)
            return;
        try {
            const value = JSON.parse(this.input.value);
            this.setOutputs(0, value);
        }
        catch (error) {
            this.input.inputEl.style.backgroundColor = "red";
            utils_1.Log.error("JSON parse error", error);
        }
    }
    setupUI() {
        this.input = this.createUI("core/input", {
            propName: "value",
            value: "",
            input: true,
            output: true,
            height: 20,
            style: { type: ui_1.InputType.Text, grow: 0.7 },
        });
        this.ui.append(this.createUI("core/x-layout", {
            childs: [this.createUI("core/label", { text: "Value", style: { grow: 0.3 } }), this.input],
            style: { spacing: 20 },
        }));
    }
    setupListeners() {
        this.watch("value", () => this.process());
    }
}
exports.JsonSource = JsonSource;
